import LeftPanel from "../LeftPanel/LeftPanel";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  return (
    <div className="logged-out page-signin">
      <section className="content-wrap light-bg">
  
        <LeftPanel heading="Terms of service" />

        <div className="col-content about w-60">
          <h3>Terms of service</h3>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
